import { useEffect, useState } from "react";
// @mui
import {
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Paper,
} from "@mui/material";

import Scrollbar from "../scrollbar";
import { get } from "src/utils/networkUtils";
import useWithUrlTenant from "src/hooks/useTenant";
export default function DivisionLeaderboardDialog(props) {
  const { clubChallengeLeaderboardId, open, onClose } = props;
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const withTenant = useWithUrlTenant();

  useEffect(() => {
    if (clubChallengeLeaderboardId) {
      setLoading(true);
      get(`/admin/club-challenges/${clubChallengeLeaderboardId}/leaderboard`)
        .then(function (response) {
          setLoading(false);
          setRows(response.leaderboard);
        })
        .catch(function (error) {
          setLoading(false);
          console.error("Error fetching leaderboard:", error);
        });
    }
  }, [clubChallengeLeaderboardId]);

  const onCancel = () => {
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={() => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">Club Challenge Leaderboard</DialogTitle>
      <DialogContent>
        {rows === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Scrollbar>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Rank</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Winnings</TableCell>
                    <TableCell>Points</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {row.rank}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <a href={withTenant(`/dashboard/profile?user_id=${row.userId}`)}>
                          {row.name}
                        </a>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <img
                            src="/assets/icons/ufcoin.svg"
                            alt="coin"
                            style={{ width: 16, height: 16 }}
                          />
                          {row.draftWinnings}
                        </Box>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.score}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
